import React from 'react';
import { GetTermsEmbed } from '../components/GetTermsEmbed';
export function Terms() {
  return <section className="w-full bg-white" data-id="element-348" data-mp="3tohcb5ihvumx">
      <article className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-20 lg:py-24" aria-labelledby="terms-title" data-id="element-349" data-mp="3tpaedt6idvyq">
        <header className="border-b border-border pb-8 sm:pb-10" data-id="element-350" data-mp="7964o4neattc">
          <h1 id="terms-title" className="font-heading text-3xl font-bold tracking-tight text-deep-navy sm:text-4xl" data-id="element-351" data-mp="7ar2q48x4uvy">
            利用規約
          </h1>
        </header>

        <div className="pt-10 text-text sm:pt-12" data-id="element-352" data-mp="gc7as5c9gkx0">
          <GetTermsEmbed documentName="terms-of-service" data-id="element-353" data-mp="l8xrmuvw3kjh" />
        </div>
      </article>
    </section>;
}